// 시안 v6 관리자 메뉴 공통 문: 신원은 직원 토큰(v6common/auth.js)이다.
// 내 정보가 없으면 안내, ownerOnly 메뉴(계약 「(대표)」)는 role owner 만 통과한다. 서버도 직원이면 403 forbidden 으로 막는다.
import { getMe, isOwner } from "./auth";

export default function AdminGate({ ownerOnly = false, children }) {
    const me = getMe();
    let msg = null;
    if (!me) msg = "로그인 정보가 없습니다. 다시 로그인해 주세요.";
    else if (ownerOnly && !isOwner(me)) msg = "대표관리자만 볼 수 있는 메뉴입니다.";
    if (msg) {
        return <div className="actorbar" style={{ marginTop: 24 }}><i className="fa-solid fa-user-shield"></i>{msg}</div>;
    }
    return typeof children === "function" ? children(me.id) : children;
}
